import { ButtonUnstyled } from '@sketch/components';
import styled from 'styled-components';
import '../ResponsiveImage/index.js';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage.js';

const StyledResponsiveImage = styled(ResponsiveImage) `
  width: 100%;
  margin-bottom: 8px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.radii.xlarge};
  overflow: hidden;
  aspect-ratio: 1/1;
`;
const Title = styled.h1 `
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const Description = styled.p `
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights.E};
`;
const StyledButton = styled(ButtonUnstyled) `
  font-size: ${({ theme }) => theme.fontSizes.E};

  &:hover {
    ${Title} {
      color: ${({ theme }) => theme.colors.foreground.secondary.C};
      text-decoration: underline;
    }
  }
`;

export { Description, StyledButton, StyledResponsiveImage, Title };
